var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cbar",class:_vm.$style.chart},[_c('div',{ref:"barChart",style:({ width: _vm.chartWidth, height: _vm.chartHeight })})])
}
var staticRenderFns = []

export { render, staticRenderFns }